import React from 'react';
import './Title.css';

export function Title() {
  return (
    <div>
      <div>
        <h1 className="title">Pesquisa de pacientes </h1>
      </div>
    </div>

  );
}
